// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3HCLl","content":"ManualTimeModal_content__3ovO_"};